module.exports = __webpack_public_path__ + "static/media/business-model.4cfb9a4c.png";